export default __webpack_public_path__ + "static/lifeprint-1-884e012e1bbaa7e3396b2b29adb744b8.webp";